import styled from 'styled-components';
import logoGithub from '../../Components/Images/github.svg';
import logoTelegram from '../../Components/Images/Telegram.svg';
import logoLinkedin from '../../Components/Images/linkedin.svg';

const socialNetworks = [
  {
    name: 'Telegram',
    link: 'https://t.me/Itzabelli',
    logo: logoTelegram,
  },
  {
    name: 'Github',
    link: 'https://github.com/Itzabelli',
    logo: logoGithub,
  },
  {
    name: 'LinkedIn',
    link: 'https://www.linkedin.com/',
    logo: logoLinkedin,
  },
];

const SocialIcons = (props) => {
  return (
    <div className={props.className}>
      {socialNetworks.map((network, index) => (
        <a
          className="logo"
          key={index}
          href={network.link}
          target="__blank"
          rel="noreferrer"
        >
          <img src={network.logo} alt={network.name} />
        </a>
      ))}
    </div>
  );
};

export default styled(SocialIcons)`
  display: flex;
  justify-content: center;
  img {
    background-color: white;
    border-radius: 55%;
    width: 32px;
    height: 32px;
    margin: 10px;
  }
  @media (max-width: 768px) {
    justify-content: center;
  }
`;
